import type { LeaderboardEntry } from '../types/worldcup.types';

export interface SquadTvLeaderboardSlices {
  top3: LeaderboardEntry[];
  rest: LeaderboardEntry[];
}

/**
 * Splits sorted leaderboard entries for TV: fixed podium top-3 + remainder.
 * The scroll list still includes ranks 1–3 (merged with rest in SquadTvDisplay).
 * Uses array index (not rank) so ties at rank 1 still show three podium slots.
 */
export function sliceLeaderboardForTvDisplay(entries: LeaderboardEntry[]): SquadTvLeaderboardSlices {
  const sorted = [...entries].sort((a, b) => a.rank - b.rank);
  return {
    top3: sorted.slice(0, 3),
    rest: sorted.slice(3),
  };
}
